export const RadnoVrijemeEvdResourceEN: RadnoVrijemeEvdInterface = {
  title: "Working time evidence",
  nextButton: "Save evidence",
  description:
    "Please select the period in which working time evidence is located.",
  inputFields: {
    endDate: {
      label: "End date",
    },
    startDate: {
      label: "Start date",
    },
    entryType: {
      error: "Please select working time evidence type.",
      label: "Working time evidence type",
      name: "entryType",
      placeholder: "Select working time evidence type",
    },
    napomena: {
      error: "Please enter note.",
      label: "Note",
      name: "napomena",
      placeholder: "Enter note if needed",
    },
    pocetak: {
      error: "Please enter working time start.",
      label: "Working time start",
      name: "pocetak",
      placeholder: "Please enter working time start",
    },
    zavrsetak: {
      error: "Please enter working time end.",
      label: "Working time end",
      name: "zavrsetak",
      placeholder: "Please enter working time end",
    },
    pocetakPauze: {
      error: "Please enter break start.",
      label: "Break start",
      name: "pocetakPauze",
      placeholder: "Please enter break start",
    },
    zavrsetakPauze: {
      error: "Please enter break end.",
      label: "Break end",
      name: "zavrsetakPauze",
      placeholder: "Please enter break end",
    },
  },
  errors: {
    errorDeleting:
      "An error occurred while deleting working time evidence. Please contact the administrator.",
    errorLoading:
      "An error occurred while loading working time evidence. Please contact the administrator.",
    errorUpdating:
      "An error occurred while saving working time evidence. Please contact the administrator.",
    errorMissingFields:
      "Please fill in required fields - working time type, working time start and working time end.",
    errorPeriodLocked:
      "The period for the selected date is locked. Changes are not allowed until the manager reopens the period.",
    errorDuplicateEntry:
      "An entry with the same type and times already exists for this day. Change the type or the schedule.",
  },
  types: {
    placeholder: "Please select working time type",
    radnovrijeme: "Working time",
    dezura: "On-call duty",
    odsustvo: "Absence",
    bolovanje: "Sick leave",
    slobodandan: "Day off",
    pripravnost: "Standby",
    radusmjenama: "Shift work",
    terenskirad: "Field work",
  },
  successModal: {
    title: "Successfully added to database",
    body: "Working time entry has been successfully saved. You can continue with changes or updates.",
    buttonOk: "OK",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface RadnoVrijemeEvdInterface {
  successModal: SuccessModal;
  title: string;
  description: string;
  nextButton: string;
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    entryType: InputFieldInterface;
    pocetak: InputFieldInterface;
    zavrsetak: InputFieldInterface;
    napomena: InputFieldInterface;
    pocetakPauze: InputFieldInterface;
    zavrsetakPauze: InputFieldInterface;
  };
  errors: {
    errorLoading: string;
    errorUpdating: string;
    errorDeleting: string;
    errorMissingFields: string;
    errorPeriodLocked: string;
    errorDuplicateEntry: string;
  };
  types: {
    placeholder: string;
    radnovrijeme: string;
    dezura: string;
    odsustvo: string;
    bolovanje: string;
    slobodandan: string;
    pripravnost: string;
    radusmjenama: string;
    terenskirad: string;
  };
}
